import { useCallback, useState } from "react"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import type { ManualReconciliationFormValues } from "../types"
import { RECONCILIATIONS_ENDPOINT, toMessage } from "./useReconciliations"

type ExecuteResult = { ok: true; result: string } | { ok: false; message: string }

/** 手動消込。成功したら消し込んだ支払予定の中身を、失敗したら例外の中身を返す（admin と同じ） */
export const useExecuteManualReconciliation = () => {
  const { postWithToken } = useSmoothApi()
  const [isExecuting, setIsExecuting] = useState(false)

  const execute = useCallback(
    async (values: ManualReconciliationFormValues): Promise<ExecuteResult> => {
      setIsExecuting(true)
      try {
        // 消込はお金の記録を作る。今の設定では POST は再送されないが、再送する条件を広げたときも二重に消し込まないようにする
        const response = await postWithToken(`${RECONCILIATIONS_ENDPOINT}/exec`, values, {
          "axios-retry": { retries: 0 },
        })
        return { ok: true, result: (response.data as { result: string }).result }
      } catch (e) {
        return { ok: false, message: toMessage(e, "消込に失敗しました。消し込めたかどうかを一覧で確認してください") }
      } finally {
        setIsExecuting(false)
      }
    },
    [postWithToken]
  )

  return { execute, isExecuting }
}
